"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseTranslations = void 0;
//import { bindings, BindingsTranslationKey } from '../bindings';
var index_1 = require("../index");
var TAG = 'BaseTranslations';
var BaseTranslations = /** @class */ (function () {
    function BaseTranslations() {
        this.data = {}; // bindings.translations;
    }
    BaseTranslations.prototype.get = function (key) {
        //        if (!this.data[key]) {
        index_1.log.warn(TAG, "Translation key ".concat(key, " is not found. Ensure it's been set ") +
            "and that it's expoed to JS in your salvo.config.js");
        return key;
        //       }
        //      return this.data[key];
    };
    return BaseTranslations;
}());
exports.BaseTranslations = BaseTranslations;
//# sourceMappingURL=BaseTranslations.js.map